import _css from "@emotion/css";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import useTheme from "../hooks/useTheme";
import { jsx as ___EmotionJSX } from "@emotion/core";

function GitHub(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      hoverColor = _ref.hoverColor,
      testId = _ref.testId;
  var theme = useTheme();
  return ___EmotionJSX("svg", {
    css: /*#__PURE__*/_css({
      display: "block",
      fill: primaryColor,
      transition: hoverColor ? theme.transitions.icon : null,
      ":hover": _objectSpread({}, hoverColor && {
        fill: hoverColor
      })
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "aria-label": "GitHub",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M15.846 4C9.304 4 4 9.148 4 15.5c0 5.08 3.394 9.388 8.102 10.91.593.105.809-.25.809-.555 0-.273-.01-.996-.016-1.955-3.295.694-3.99-1.542-3.99-1.542-.54-1.329-1.316-1.682-1.316-1.682-1.076-.713.081-.7.081-.7 1.19.083 1.815 1.186 1.815 1.186 1.057 1.757 2.772 1.25 3.448.956.107-.743.413-1.25.752-1.538-2.63-.29-5.397-1.276-5.397-5.683 0-1.255.462-2.281 1.22-3.085-.122-.29-.529-1.46.116-3.043 0 0 .995-.31 3.258 1.179a11.67 11.67 0 012.966-.388c1.006.005 2.02.132 2.966.388 2.261-1.488 3.254-1.18 3.254-1.18.647 1.584.24 2.753.118 3.044.76.804 1.218 1.83 1.218 3.085 0 4.418-2.77 5.39-5.41 5.674.426.355.805 1.057.805 2.13 0 1.537-.015 2.777-.015 3.154 0 .308.214.665.815.553 4.703-1.524 8.095-5.83 8.095-10.908C27.694 9.148 22.39 4 15.846 4",
    fillRule: "evenodd"
  }));
}

GitHub.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  hoverColor: PropTypes.string,
  testId: PropTypes.string
};
export default GitHub;